<template>
  <div>
    <v-card>
      <v-tabs v-model="tab">
        <v-tab
          v-for="item in items"
          :key="item.name"
          :name="item.name"
        >
          {{ $t(item.tab) }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.name">
          <component
            v-if="item.person !== undefined && (item.isInternal === false || isInternal === true)"
            :is="item.content"
            :person="item.person"
            class="py-6 px-6 mb-5"
          />
          <component v-else :is="item.content" class="py-6 px-6 mb-5" />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import Preferences from "./Preferences";
import PersonalData from "./PersonalData";
import PublicData from "./PublicData";
import AccountVinculationWorkplaceData from "./AccountVinculationWorkplaceData";
/*import QualificationData from "./QualificationData";*/
export default {
  components: {
    Preferences,
    PersonalData,
    PublicData,
    AccountVinculationWorkplaceData
  },
  data() {
    return {
      tab: null,
      items: [
      {
        name: "personalData",
        tab: "account.personal.data",
        content: "PersonalData",
        person: this.$store.getters.user.person,
        isInternal: false
      },
      {
        name: "statusData",
        tab: "account.status",
        content: "AccountVinculationWorkplaceData",
        person: this.$store.getters.user.person,
        isInternal: false
      },
      {
        name: "otherInfo",
        tab: "account.publicdata",
        content: "PublicData",
        isInternal: true
      },
      {
        name: "preferences",
        tab: "account.preferences.title",
        content: "Preferences",
        isInternal: true
      }
      ].filter(item => item.isInternal === false || this.$store.getters.isInternal === true)
    }
  },
  watch: {
    tab(val) {
      const item = this.items[val];
      if (!item) {
        return;
      }
      const hash = `#${item.name}`;
      if (this.$route.hash !== hash) {
        this.$router.replace({ hash });
      }
    },
    "$route.hash"() {
      this.syncTabWithHash();
    }
  },
  created() {
    this.syncTabWithHash();
  },
  methods: {
    syncTabWithHash() {
      const hash = (this.$route.hash || "").replace("#", "");
      const normalizedHash = hash === "publicData" ? "otherInfo" : hash;
      const index = this.items.findIndex(item => item.name === normalizedHash);
      this.tab = index > -1 ? index : 0;
      const currentItem = this.items[this.tab];
      if (currentItem) {
        const expectedHash = `#${currentItem.name}`;
        if (this.$route.hash !== expectedHash) {
          this.$router.replace({ hash: expectedHash });
        }
      }
    }
  }
};
</script>
